// extracted by mini-css-extract-plugin
module.exports = {"reasons":"styles-module--reasons--Gu4zn","reasons__cards":"styles-module--reasons__cards--3-3JL","reasons__reasons":"styles-module--reasons__reasons--1_JFu"};